import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { FaGithub } from "react-icons/fa"
import { BsArrowRight } from "react-icons/bs"

const SingleFeaturedProject = ({ project }) => {
  return (
    <div className="pt-6 pb-10 md:py-16">
      <div className="w-full">
        <Img
          className="object-cover"
          fluid={project.image.fluid}
          alt="card-image"
        />
      </div>
      <div className="flex flex-col items-center pt-8">
        <div className="text-3xl md:text-5xl lg:text-6xl text-white font-bold leading-tight">
          <span className="bg-clip-text text-transparent bg-gradient-to-br from-gray-800 via-white to-gray-800">
            {project.title}
          </span>
        </div>
        <div className="flex flex-row flex-wrap py-6 md:py-10 items-center justify-center md:mx-5">
          {project.techStack.map(item => {
            return (
              <div className="px-2 md:px-4 lg:px-6 pt-1 pb-1 md:pt-2 md:pb-2 mx-2 mb-2 bg-stack text-white font-metropolis font-light md:font-thin tracking-wide rounded-md text-xs md:text-sm uppercase">
                {item}
              </div>
            )
          })}
        </div>
        <p className="md:px-16 xl:px-24 px-3 pt-2 md:pt-6 lg:pt-8 text-white text-sm md:text-xl font-metropolis font-light tracking-normal text-left md:text-center opacity-75">
          {project.description.description}
        </p>
        <div className="flex w-full justify-around mt-12 md:mt-16 text-base md:text-lg">
          <Link to={project.github} target="_blank">
            <button
              className="flex items-center py-2 px-6 md:px-8 font-metropolis
              font-medium text-sm md:text-base bg-white hover:bg-gray-200 border border-white uppercase tracking-wide transition-all duration-300 ease-linear mr-3 md:mr-8 focus:outline-none text-black"
            >
              Github{" "}
              <div className="pl-2 md:pl-4">
                <FaGithub className="text-black text-base md:text-xl" />
              </div>
            </button>
          </Link>
          <Link
            to={project.liveDemo}
            target="_blank"
            className="flex items-center justify-center ml-3 md:ml-8 font-metropolis
              font-normal lg:text-lg tracking-wide cursor-pointer hvr-underline-from-left hover:text-white transition-all duration-300 ease-linear text-yellow-500"
          >
            Live Demo
            <div className="pl-4">
              <BsArrowRight className="text-xl md:text-2xl" />
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default SingleFeaturedProject
